import React from 'react';
import { Link } from 'react-router-dom';
import { Home } from 'react-feather';
import { useDarkMode } from './DarkModeContext';
import Footer from './Footer';

function NotFound() {
    const { darkMode } = useDarkMode();
    
    return (
        <div style={{ 
            maxWidth: '800px', 
            margin: '0 auto', 
            padding: '20px',
            fontFamily: 'Arial, sans-serif',
            lineHeight: '1.6',
            color: darkMode ? '#e0e0e0' : '#333',
            backgroundColor: darkMode ? '#1a1a1a' : 'white',
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center'
        }}>
            <div style={{ marginBottom: '40px' }}>
                <h1 style={{ 
                    fontSize: '120px',
                    fontWeight: 'bold',
                    margin: 0,
                    color: darkMode ? '#4A9EFF' : '#1976d2',
                    lineHeight: '1'
                }}>
                    404
                </h1>
                <h2 style={{ 
                    color: darkMode ? '#ffffff' : '#2c3e50', 
                    marginTop: '20px',
                    marginBottom: '20px',
                    fontSize: '32px'
                }}>
                    Page Not Found
                </h2>
                <p style={{ 
                    fontSize: '18px',
                    color: darkMode ? '#e0e0e0' : '#666',
                    marginBottom: '40px',
                    maxWidth: '500px',
                    margin: '0 auto 40px auto'
                }}>
                    Oops! The page you're looking for doesn't exist. It might have been moved, deleted, or you entered the wrong URL.
                </p>
            </div>

            <div style={{ 
                display: 'flex',
                flexDirection: 'column',
                gap: '20px',
                alignItems: 'center'
            }}>
                <Link 
                    to="/"
                    style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '10px',
                        padding: '12px 30px',
                        backgroundColor: darkMode ? '#4A9EFF' : '#1976d2',
                        color: 'white',
                        textDecoration: 'none',
                        borderRadius: '8px',
                        fontWeight: 'bold',
                        fontSize: '16px',
                        transition: 'background-color 0.2s',
                        boxShadow: darkMode ? '0 4px 12px rgba(74, 158, 255, 0.3)' : '0 4px 12px rgba(25, 118, 210, 0.3)'
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = darkMode ? '#3a8eef' : '#1565c0';
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = darkMode ? '#4A9EFF' : '#1976d2';
                    }}
                >
                    <Home size={20} />
                    Go to Homepage
                </Link>

                <div style={{ 
                    marginTop: '40px',
                    padding: '30px',
                    backgroundColor: darkMode ? '#2a2a2a' : '#f8f9fa',
                    borderRadius: '8px',
                    border: `1px solid ${darkMode ? '#444' : '#e0e0e0'}`,
                    maxWidth: '600px'
                }}>
                    <h3 style={{ 
                        color: darkMode ? '#ffffff' : '#2c3e50',
                        marginTop: 0,
                        marginBottom: '20px'
                    }}>
                        Popular Pages
                    </h3>
                    <div style={{ 
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '12px',
                        alignItems: 'flex-start'
                    }}>
                        <Link 
                            to="/landing-page"
                            style={{
                                color: darkMode ? '#4A9EFF' : '#1976d2',
                                textDecoration: 'none',
                                fontSize: '16px'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.textDecoration = 'underline';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.textDecoration = 'none';
                            }}
                        >
                            → Landing Page
                        </Link>
                        <Link 
                            to="/pricing"
                            style={{
                                color: darkMode ? '#4A9EFF' : '#1976d2',
                                textDecoration: 'none',
                                fontSize: '16px'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.textDecoration = 'underline';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.textDecoration = 'none';
                            }}
                        >
                            → Pricing
                        </Link>
                        <Link 
                            to="/about"
                            style={{
                                color: darkMode ? '#4A9EFF' : '#1976d2',
                                textDecoration: 'none',
                                fontSize: '16px'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.textDecoration = 'underline';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.textDecoration = 'none';
                            }}
                        >
                            → About
                        </Link>
                        <Link 
                            to="/contact"
                            style={{
                                color: darkMode ? '#4A9EFF' : '#1976d2',
                                textDecoration: 'none',
                                fontSize: '16px'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.textDecoration = 'underline';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.textDecoration = 'none';
                            }}
                        >
                            → Contact
                        </Link>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}

export default NotFound;

